module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="accountBar__dropdownButton"><i class="icon icon-i16_ava"></i> <span class="accountBar__userName"></span></div>\n<div class="accountBar__dropdown">\n	<ul class="accountBar__linksMenu">\n		<li><a target="_blank" href="'+
((__t=( accountDomain ))==null?'':__t)+
'/#/orders">Заказы</a></li>\n		<li><a target="_blank" href="'+
((__t=( accountDomain ))==null?'':__t)+
'/#/settings">Настройки</a></li>\n		<li class="accountBar__logoutWrapper"><span class="accountBar__logout">Выйти <i class="icon"></i></span></li>\n	</ul>\n</div>';
}
return __p;
};
